import { render, staticRenderFns } from "./IcoContractRejected.vue?vue&type=template&id=b6639812&scoped=true"
import script from "./IcoContractRejected.vue?vue&type=script&lang=js"
export * from "./IcoContractRejected.vue?vue&type=script&lang=js"
import style0 from "./IcoContractRejected.vue?vue&type=style&index=0&id=b6639812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6639812",
  null
  
)

export default component.exports